import { observer } from 'mobx-react';

// Components
import { SearchOutlined } from '@ant-design/icons';

// Hooks
import { useStores } from 'hooks/use-stores';
import { TODO } from 'utils/Types';
import { InputSearch } from './styles';

interface LocationSearchProps {
  onSearch: (event: any) => void;
  searchPlaceholderText: string;
  searchButtonText: string;
  classes: string;
  style: TODO;
}

const LocationSearch = ({ classes, onSearch, searchButtonText, searchPlaceholderText, style }: LocationSearchProps) => {
  const { uiState } = useStores();

  const handleSearch = (value: string) => {
    const formattedValue = value.trim().replaceAll(' ', '');
    onSearch(formattedValue);
  };

  return (
    <InputSearch
      allowClear
      className={classes}
      data-testid="location-search-input"
      enterButton={searchButtonText}
      onSearch={handleSearch}
      placeholder={searchPlaceholderText}
      prefix={uiState.isMobile ? null : <SearchOutlined />}
      size="medium"
      style={style}
    />
  );
};

export default observer(LocationSearch);
